// Email template utilities and HTML templates for Solis Games
// Uses brand colors from tailwind.css: primary #6366F1, secondary #8B5CF6, background #0F172A

export const EMAIL_TEMPLATES = {
  // Base HTML template with Solis Games branding
  BASE_TEMPLATE: `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>{{subject}}</title>
    <style>
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        
        body {
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            line-height: 1.6;
            color: #F8FAFC;
            background-color: #0F172A;
        }
        
        .email-container {
            max-width: 600px;
            margin: 0 auto;
            background-color: #1E293B;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
        }
        
        .email-header {
            background: linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%);
            padding: 32px 24px;
            text-align: center;
        }
        
        .logo {
            width: 120px;
            height: auto;
            margin-bottom: 16px;
        }
        
        .header-title {
            color: #FFFFFF;
            font-size: 24px;
            font-weight: 700;
            margin: 0;
        }
        
        .email-body {
            padding: 32px 24px;
        }
        
        .greeting {
            font-size: 18px;
            font-weight: 600;
            color: #F8FAFC;
            margin-bottom: 16px;
        }
        
        .content {
            font-size: 16px;
            color: #CBD5E1;
            margin-bottom: 24px;
            line-height: 1.7;
        }
        
        .content p {
            margin-bottom: 16px;
        }
        
        .content ul {
            margin: 16px 0;
            padding-left: 20px;
        }
        
        .content li {
            margin-bottom: 8px;
            color: #CBD5E1;
        }
        
        .button {
            display: inline-block;
            background: linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%);
            color: #FFFFFF;
            text-decoration: none;
            padding: 14px 28px;
            border-radius: 8px;
            font-weight: 600;
            font-size: 16px;
            margin: 16px 0;
            transition: transform 0.2s ease;
        }
        
        .button:hover {
            transform: translateY(-2px);
        }
        
        .button-secondary {
            background: transparent;
            border: 2px solid #6366F1;
            color: #6366F1;
        }
        
        .divider {
            height: 1px;
            background: rgba(148, 163, 184, 0.2);
            margin: 32px 0;
        }
        
        .ticket-info {
            background-color: #334155;
            border-radius: 8px;
            padding: 20px;
            margin: 24px 0;
            border-left: 4px solid #6366F1;
        }
        
        .ticket-info h3 {
            color: #F8FAFC;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 8px;
        }
        
        .ticket-info p {
            color: #94A3B8;
            font-size: 14px;
            margin: 4px 0;
        }
        
        .admin-message {
            background-color: #0F172A;
            border-radius: 8px;
            padding: 20px;
            margin: 20px 0;
            border-left: 4px solid #10B981;
        }
        
        .admin-message .admin-name {
            color: #10B981;
            font-weight: 600;
            font-size: 14px;
            margin-bottom: 8px;
        }
        
        .admin-message .message-content {
            color: #CBD5E1;
            line-height: 1.6;
        }
        
        .email-footer {
            background-color: #0F172A;
            padding: 24px;
            text-align: center;
            border-top: 1px solid rgba(148, 163, 184, 0.1);
        }
        
        .footer-text {
            color: #64748B;
            font-size: 14px;
            margin-bottom: 16px;
        }
        
        .footer-links {
            margin: 16px 0;
        }
        
        .footer-links a {
            color: #6366F1;
            text-decoration: none;
            margin: 0 12px;
            font-size: 14px;
        }
        
        .footer-links a:hover {
            text-decoration: underline;
        }
        
        .social-links {
            margin-top: 16px;
        }
        
        .social-links a {
            display: inline-block;
            margin: 0 8px;
            color: #64748B;
            text-decoration: none;
        }
        
        .unsubscribe {
            color: #64748B;
            font-size: 12px;
            margin-top: 16px;
        }
        
        .unsubscribe a {
            color: #64748B;
            text-decoration: underline;
        }
        
        /* Responsive design */
        @media only screen and (max-width: 600px) {
            .email-container {
                margin: 0;
                border-radius: 0;
            }
            
            .email-header,
            .email-body,
            .email-footer {
                padding: 24px 16px;
            }
            
            .header-title {
                font-size: 20px;
            }
            
            .greeting {
                font-size: 16px;
            }
            
            .content {
                font-size: 15px;
            }
            
            .button {
                display: block;
                text-align: center;
                margin: 20px 0;
            }
        }
    </style>
</head>
<body>
    <div class="email-container">
        <div class="email-header">
            <img src="https://solisgames.com/assets/images/solis-games-logo.png" alt="Solis Games" class="logo">
            <h1 class="header-title">{{header_title}}</h1>
        </div>
        
        <div class="email-body">
            {{body_content}}
        </div>
        
        <div class="email-footer">
            <p class="footer-text">
                This email was sent by Solis Games Support Team
            </p>
            <div class="footer-links">
                <a href="https://solisgames.com">Visit Website</a>
                <a href="https://solisgames.com/library">Game Library</a>
                <a href="https://solisgames.com/contact">Contact Support</a>
            </div>
            <div class="unsubscribe">
                <p>Solis Games | Gaming Platform</p>
                {{#if unsubscribe_url}}
                <p><a href="{{unsubscribe_url}}">Unsubscribe from these emails</a></p>
                {{/if}}
            </div>
        </div>
    </div>
</body>
</html>`,

  // Welcome email template
  WELCOME: {
    subject: 'Welcome to Solis Games - Start Gaming Now!',
    body: '<div class="greeting">Hi {{user_name}}! 👋</div>' +
        '<div class="content">' +
            '<p>Welcome to <strong>Solis Games</strong>! We\'re thrilled to have you join our gaming community.</p>' +
            '<p>Your account is now active and you can start exploring our incredible game library. Here\'s what you can do:</p>' +
            '<ul>' +
                '<li>🎮 Browse 500+ games in our library</li>' +
                '<li>⚡ Play instantly in your browser</li>' +
                '<li>❤️ Save your favorite games</li>' +
                '<li>📊 Track your gaming progress</li>' +
                '<li>🌟 Discover new games weekly</li>' +
            '</ul>' +
            '<p>Ready to start your gaming adventure?</p>' +
        '</div>' +
        '<div style="text-align: center;">' +
            '<a href="{{dashboard_url}}" class="button">Start Gaming Now</a>' +
        '</div>' +
        '<div class="divider"></div>' +
        '<div class="content">' +
            '<p><strong>Need help getting started?</strong></p>' +
            '<p>Our support team is here to help you make the most of your Solis Games experience. Feel free to reach out anytime!</p>' +
        '</div>'
  },

  // Contact admin reply template
  CONTACT_ADMIN_REPLY: {
    subject: 'Re: {{subject}} [Ticket #{{ticket_id}}]',
    body: '<div class="greeting">Hi {{user_name}},</div>' +
        '<div class="content">' +
            '<p>Thank you for contacting Solis Games support. We\'ve received your message and one of our team members has responded:</p>' +
        '</div>' +
        '<div class="admin-message">' +
            '<div class="admin-name">{{admin_name}} - Solis Games Support</div>' +
            '<div class="message-content">{{admin_message}}</div>' +
        '</div>' +
        '<div class="content">' +
            '<p><strong>Need to continue the conversation?</strong> Simply reply to this email and we\'ll add your response to the ticket.</p>' +
        '</div>' +
        '<div class="ticket-info">' +
            '<h3>Ticket Information</h3>' +
            '<p><strong>Ticket ID:</strong> #{{ticket_id}}</p>' +
            '<p><strong>Subject:</strong> {{subject}}</p>' +
            '<p><strong>Status:</strong> {{status}}</p>' +
            '{{#if ticket_url}}' +
            '<p><a href="{{ticket_url}}" style="color: #6366F1;">View Full Ticket</a></p>' +
            '{{/if}}' +
        '</div>'
  },

  // Contact status update template
  CONTACT_STATUS_UPDATE: {
    subject: 'Your support ticket has been {{status}} [Ticket #{{ticket_id}}]',
    body: '<div class="greeting">Hi {{user_name}},</div>' +
        '<div class="content">' +
            '<p>We wanted to update you on your support ticket:</p>' +
        '</div>' +
        '<div class="ticket-info">' +
            '<h3>Ticket Update</h3>' +
            '<p><strong>Subject:</strong> {{subject}}</p>' +
            '<p><strong>Status:</strong> <span style="color: {{status_color}}; font-weight: 600;">{{status_display}}</span></p>' +
            '<p><strong>Updated:</strong> {{updated_at}}</p>' +
        '</div>' +
        '{{#if admin_note}}' +
        '<div class="admin-message">' +
            '<div class="admin-name">Note from our team:</div>' +
            '<div class="message-content">{{admin_note}}</div>' +
        '</div>' +
        '{{/if}}' +
        '<div class="content">' +
            '{{#if status_resolved}}' +
            '<p>🎉 <strong>Great news!</strong> Your ticket has been resolved. We hope we were able to help you successfully.</p>' +
            '<p>If you need further assistance with this issue, simply reply to this email and we\'ll reopen your ticket right away.</p>' +
            '{{else}}' +
            '<p>We\'ll continue working on your ticket and keep you updated on any progress.</p>' +
            '<p>Have additional information to share? Just reply to this email to add it to your ticket.</p>' +
            '{{/if}}' +
        '</div>' +
        '{{#if ticket_url}}' +
        '<div style="text-align: center;">' +
            '<a href="{{ticket_url}}" class="button-secondary">View Ticket Details</a>' +
        '</div>' +
        '{{/if}}'
  },

  // Subscription confirmation template
  SUBSCRIPTION_CONFIRMATION: {
    subject: 'Welcome to Solis Games Premium! 🎮',
    body: '<div class="greeting">Congratulations {{user_name}}! 🎉</div>' +
        '<div class="content">' +
            '<p>Your <strong>{{plan_name}}</strong> subscription is now active! You now have unlimited access to our entire game library.</p>' +
            '<p><strong>What\'s included in your subscription:</strong></p>' +
            '<ul>' +
                '{{#each plan_features}}' +
                '<li>{{this}}</li>' +
                '{{/each}}' +
            '</ul>' +
        '</div>' +
        '<div class="ticket-info">' +
            '<h3>Subscription Details</h3>' +
            '<p><strong>Plan:</strong> {{plan_name}}</p>' +
            '<p><strong>Price:</strong> ${{plan_price}}/month</p>' +
            '<p><strong>Next billing date:</strong> {{next_billing_date}}</p>' +
            '<p><strong>Subscription ID:</strong> {{subscription_id}}</p>' +
        '</div>' +
        '<div style="text-align: center;">' +
            '<a href="{{dashboard_url}}" class="button">Start Gaming Now</a>' +
            '<a href="{{manage_subscription_url}}" class="button-secondary">Manage Subscription</a>' +
        '</div>' +
        '<div class="divider"></div>' +
        '<div class="content">' +
            '<p><strong>Questions about your subscription?</strong></p>' +
            '<p>Visit your account settings to manage your subscription, update payment methods, or contact our support team.</p>' +
        '</div>'
  },

  // Subscription payment success template
  SUBSCRIPTION_PAYMENT_SUCCESS: {
    subject: 'Payment Confirmed - Solis Games Premium',
    body: '<div class="greeting">Hi {{user_name}},</div>' +
        '<div class="content">' +
            '<p>Thank you! Your payment for <strong>{{plan_name}}</strong> has been successfully processed.</p>' +
        '</div>' +
        '<div class="ticket-info">' +
            '<h3>Payment Details</h3>' +
            '<p><strong>Amount:</strong> ${{amount}}</p>' +
            '<p><strong>Payment date:</strong> {{payment_date}}</p>' +
            '<p><strong>Next billing date:</strong> {{next_billing_date}}</p>' +
            '<p><strong>Payment method:</strong> {{payment_method}}</p>' +
        '</div>' +
        '<div class="content">' +
            '<p>Your premium access continues uninterrupted. Enjoy gaming!</p>' +
        '</div>' +
        '<div style="text-align: center;">' +
            '<a href="{{dashboard_url}}" class="button">Continue Gaming</a>' +
            '<a href="{{billing_history_url}}" class="button-secondary">View Billing History</a>' +
        '</div>'
  },

  // Subscription payment failed template
  SUBSCRIPTION_PAYMENT_FAILED: {
    subject: 'Action Required - Payment Issue with Your Solis Games Subscription',
    body: '<div class="greeting">Hi {{user_name}},</div>' +
        '<div class="content">' +
            '<p>We encountered an issue processing your payment for <strong>{{plan_name}}</strong>.</p>' +
            '<p><strong>What happened:</strong> {{failure_reason}}</p>' +
            '<p>Don\'t worry - your account is still active for now, but we\'ll need you to update your payment information to continue your subscription.</p>' +
        '</div>' +
        '<div class="ticket-info">' +
            '<h3>Payment Details</h3>' +
            '<p><strong>Amount:</strong> ${{amount}}</p>' +
            '<p><strong>Attempted on:</strong> {{payment_date}}</p>' +
            '<p><strong>Payment method:</strong> {{payment_method}}</p>' +
            '<p><strong>Next retry:</strong> {{retry_date}}</p>' +
        '</div>' +
        '<div style="text-align: center;">' +
            '<a href="{{update_payment_url}}" class="button">Update Payment Method</a>' +
        '</div>' +
        '<div class="content">' +
            '<p><strong>Need help?</strong> Our support team is here to assist you with any payment issues.</p>' +
        '</div>'
  },

  // Subscription cancelled template
  SUBSCRIPTION_CANCELLED: {
    subject: 'Your Solis Games subscription has been cancelled',
    body: '<div class="greeting">Hi {{user_name}},</div>' +
        '<div class="content">' +
            '<p>We\'ve successfully cancelled your <strong>{{plan_name}}</strong> subscription as requested.</p>' +
            '<p><strong>Important details:</strong></p>' +
            '<ul>' +
                '<li>Your premium access continues until <strong>{{access_ends_date}}</strong></li>' +
                '<li>No further charges will be made to your account</li>' +
                '<li>You can reactivate anytime before your access expires</li>' +
            '</ul>' +
        '</div>' +
        '<div class="content">' +
            '<p>We\'re sorry to see you go! If you cancelled due to an issue, we\'d love to help resolve it.</p>' +
        '</div>' +
        '<div style="text-align: center;">' +
            '<a href="{{reactivate_url}}" class="button-secondary">Reactivate Subscription</a>' +
            '<a href="{{feedback_url}}" class="button-secondary">Share Feedback</a>' +
        '</div>' +
        '<div class="divider"></div>' +
        '<div class="content">' +
            '<p>Thank you for being part of the Solis Games community. You\'re always welcome back!</p>' +
        '</div>'
  }
}

// Helper function to get template by type
export function getEmailTemplate(templateType) {
  const templates = {
    'welcome': EMAIL_TEMPLATES.WELCOME,
    'contact_admin_reply': EMAIL_TEMPLATES.CONTACT_ADMIN_REPLY,
    'contact_status_update': EMAIL_TEMPLATES.CONTACT_STATUS_UPDATE,
    'subscription_confirmation': EMAIL_TEMPLATES.SUBSCRIPTION_CONFIRMATION,
    'subscription_payment_success': EMAIL_TEMPLATES.SUBSCRIPTION_PAYMENT_SUCCESS,
    'subscription_payment_failed': EMAIL_TEMPLATES.SUBSCRIPTION_PAYMENT_FAILED,
    'subscription_cancelled': EMAIL_TEMPLATES.SUBSCRIPTION_CANCELLED
  }
  
  return templates[templateType] || null
}

// Helper function to process template with data
export function processEmailTemplate(templateType, data = {}) {
  const template = getEmailTemplate(templateType)
  if (!template) {
    throw new Error(`Template not found: ${templateType}`)
  }
  
  // Merge template body into base template
  const fullTemplate = EMAIL_TEMPLATES.BASE_TEMPLATE
    .replace('{{body_content}}', template.body)
    .replace('{{header_title}}', data.header_title || 'Solis Games')
  
  // Process all variables safely
  let processed = fullTemplate
  Object.keys(data).forEach(key => {
    const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g')
    const value = data[key]
    processed = processed.replace(regex, value !== undefined && value !== null ? String(value) : '')
  })
  
  // Handle conditional blocks
  processed = processed.replace(/{{#if\s+(\w+)}}(.*?){{\/if}}/gs, (match, condition, content) => {
    return data[condition] ? content : ''
  })
  
  processed = processed.replace(/{{#unless\s+(\w+)}}(.*?){{\/unless}}/gs, (match, condition, content) => {
    return !data[condition] ? content : ''
  })
  
  // Handle each loops
  processed = processed.replace(/{{#each\s+(\w+)}}(.*?){{\/each}}/gs, (match, arrayName, content) => {
    const array = data[arrayName]
    if (!Array.isArray(array)) return ''
    
    return array.map(item => {
      return content.replace(/{{this}}/g, String(item))
    }).join('')
  })
  
  // Clean up any remaining unprocessed variables to prevent errors
  processed = processed.replace(/{{[^}]+}}/g, '')
  
  return {
    subject: processSimpleTemplate(template.subject, data),
    html: processed
  }
}

// Helper function for simple template processing
function processSimpleTemplate(template, data = {}) {
  let processed = template
  Object.keys(data).forEach(key => {
    const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g')
    const value = data[key]
    processed = processed.replace(regex, value !== undefined && value !== null ? String(value) : '')
  })
  
  // Clean up any remaining unprocessed variables
  processed = processed.replace(/{{[^}]+}}/g, '')
  
  return processed
}

// Status color mapping
export const STATUS_COLORS = {
  'open': '#DC2626',
  'in_progress': '#D97706', 
  'resolved': '#059669',
  'closed': '#64748B'
}

// Status display names
export const STATUS_DISPLAY = {
  'open': 'Open',
  'in_progress': 'In Progress',
  'resolved': 'Resolved',
  'closed': 'Closed'
}
